module.exports = __webpack_public_path__ + "assets/visa-logo.c01dbff4.svg";